namespace advisorop.components.advisor {

    class CuHouseholdController {
        onHouseholdCu: any;
        onRtgCu: any;
        dg;
        household: domains.IHousehold;
        rtgPanelVisible: boolean = false;
        investorPanelVisible: boolean = true;
        advisoryFirms: domains.IAdvisoryFirm[] = [];
        selAdvisoryFirm: domains.IAdvisoryFirm = null;

        accountGroupViews: domains.ILOV[];
        selAccountGroupView: domains.ILOV = null;

        defaultAccountGroupViews: domains.ILOV[];
        selDefaultAccountGroupView: domains.ILOV = null;

        advisoryFirmId: number;
        user: domains.identity.IUser;
        currentAdvisor: domains.IAdvisor;
        laddaOperationInProgress: boolean = false;
        //Section of mailing address variables 

        typeMailingState = false;
        states: domains.ILOV[] = [];
        lovs: Array<domains.ILOV> = [];
        selMailingCountry: domains.ILOV;
        selMailingState: domains.ILOV;
        selStreetState: domains.ILOV;
        usCountryCode: string = "US";
        citizenships: domains.ILOV[] = [];
        recordStatusDeleted = domains.RecordStatus.DELETED;
        recordStatusExpired = domains.RecordStatus.EXPIRED;

        //End of section

        static $inject = ["advisorService", "generalService", "advisoryFirmApi", "$scope"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private $scope: ng.IScope) {

            if (this.household == null) {
                this.household = {};
                this.household.investors = [];
            }

            this.dg = {
                bindingOptions: {
                    dataSource: "vm.household.investors"
                },
                // height: "80px",
                paging: { pageSize: 3 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "There is no Individuals",
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgInvestorSettings"
                //},
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'fullName', caption: 'Name', width: 160 },
                    { dataField: 'tinForPublic', caption: 'TIN/SSN', width: 140, visible: false },
                    { dataField: 'fullAddress', caption: 'Address' },
                    { dataField: 'id', caption: '#', cellTemplate: 'btnActions', width: 100 }

                ]
            };
        }

        investorSelected(investor: domains.IInvestor) {

            investor.companyGroup = null;
            if (!this.household.investors)
                this.household.investors = [];
            this.household.investors.push(investor);
        };

        advisoryFirmChanged() {
            if (this.selAdvisoryFirm)
                this.household.advisoryFirmId = this.selAdvisoryFirm.id;
            else
                this.household.advisoryFirmId = null;
        };

        removeInvestor(investor: domains.IInvestor): void {
            var ind = this.household.investors.indexOf(investor);
            if (ind >= 0) {
                this.household.investors.splice(ind, 1);
            }
        };

        validateCuHouseholdForm(): boolean {
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["formCuHousehold"]);

            if (!this.selAdvisoryFirm) {
                formIsValid = false;
                toastr.error("Please provide Advisory Firm");
            }

            if (!formIsValid)
                toastr.error("Household form is not complete. Please correct errors and try again");

            return formIsValid;
        };

        saveHousehold(): void {
            var h: domains.IHousehold = {};

            if (!this.validateCuHouseholdForm()) return;

            this.household.advisoryFirmId = this.selAdvisoryFirm.id;
            this.household.accountGroupView = this.selAccountGroupView.value;
            this.household.defaultAccountGroupView = this.selDefaultAccountGroupView.value;
            angular.copy(this.household, h);

            if (this.selMailingCountry)
                this.household.mailingCountryId = this.selMailingCountry.extra2;

            if (this.typeMailingState == false && this.selMailingState)
                this.household.mailingState = this.selMailingState.extra1;

            h.companyGroup = null;
            for (var i = 0; i < h.investors.length; i++) {
                h.investors[i].companyGroup = null;
            }
            h.rtgs = [];

            this.laddaOperationInProgress = true;

            this.advisorService.createUpdateHousehold(h)
                .then(data => {
                    this.onHouseholdCu({ household: data.data });
                    this.investorPanelVisible = false;
                    this.rtgPanelVisible = true;
                })
                .catch(data => {
                    toastr.error("Household has not been saved! Error " + data.status + " " + data.data);
                })
                .finally(() => {
                    this.laddaOperationInProgress = false;
                });
        }

        expireHousehold(): void {
            var msg = "If you select this option, you will no longer be able to use and search this household."
                + "\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";
            if (window.confirm(msg)) {
                console.log('Expire household....');
                this.laddaOperationInProgress = true;
                this.advisorService.expireHousehold(this.household.id)
                    .then(data => {
                        this.household = data.data;
                        toastr.success("Household has been marked as expired.");
                    })
                    .catch(data => {
                        toastr.error("Household has not been marked as expired! Error " + data.status + " " + data.data);
                    })
                    .finally(() => {
                        this.laddaOperationInProgress = false;
                    });
            }
        }


        deleteHousehold(): void {
            var msg = "If you select this option, you will no longer be able to use this household."
                + "\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";
            if (window.confirm(msg)) {

                this.laddaOperationInProgress = true;

                this.advisorService.removeHousehold(this.household.id)
                    .then(data => {
                        this.household = null;
                        toastr.success("Household has been deleted.");
                    })
                    .catch(data => {
                        toastr.error("Household has not been deleted! Error " + data.status + " " + data.data);
                    })
                    .finally(() => {
                        this.laddaOperationInProgress = false;
                    });
            }
        }

        mailingAddressChanged(): void {
            if (this.selMailingCountry != null && this.selMailingCountry.extra2 == this.usCountryCode)
                this.typeMailingState = false;
            if (this.typeMailingState == true)
                this.selMailingState = <domains.ILOV>{};
        }

        copyMailingAddressFromInvestor(investor: domains.IInvestor): void {

            this.household.mailingAddress1 = investor.mailingAddress1;
            this.household.mailingAddress2 = investor.mailingAddress2;
            this.household.mailingCity = investor.mailingCity;
            this.household.mailingPostCode = investor.mailingPostCode;

            this.selMailingCountry = <domains.ILOV>{ extra2: investor.mailingCountryId };

            var mstate = this.states.filter(v => v.extra1 === investor.mailingState);
            if (mstate.length > 0) {
                this.typeMailingState = false;
                this.selMailingState = mstate[0];
            } else {
                this.typeMailingState = true;
                this.selMailingState = <domains.ILOV>{};
            }


            this.household.mailingCountryId = investor.mailingCountryId;
            this.household.mailingState = investor.mailingState;

        };

        rtqSelected(rtq: domains.IRTQ): void {

        };

        rtqCreated(rtq: domains.IRTQ): void {
            if (rtq) {
                toastr.info("RTQ has been successfully completed.");
                let newRtg: domains.IAccountGroup = {
                    id: 0,
                    householdId: this.household.id,
                    rtq: rtq,
                    rtqId: rtq.id
                };

                this.household.rtgs.push(newRtg);
                this.onRtgCu({ rtg: newRtg });
            }
        };

        loadAdvisoryFirms(): ng.IPromise<void> {
            return this.advisoryFirmApi.getAdvisoryFirms()
                .then(response => {
                    if (this.advisoryFirmId > 0) {
                        this.advisoryFirms = response.data.filter(v => v.id === this.advisoryFirmId);
                        this.selAdvisoryFirm = this.advisoryFirms[0];
                        // console.log("Advisory firms filtered...", this.advisoryFirmId, this.advisoryFirms, this.selAdvisoryFirm);
                    } else {
                        this.advisoryFirms = response.data;
                    }
                }, err => this.generalService.showError(err.data));
        };

        bindHouseholdSelections(): void {
            var mstate = this.states.filter(v => v.extra1 === this.household.mailingState);
            if (mstate.length > 0) {
                this.typeMailingState = false;
                this.selMailingState = mstate[0];
            } else {
                this.selMailingState = <domains.ILOV>{};
            }

            this.selMailingCountry = <domains.ILOV>{ extra2: this.household.mailingCountryId };
        }

        loadHousehold(id: number): ng.IPromise<domains.IHousehold> {
            return this.advisorService.getHousehold(id).then(data => {
                this.household = data.data;
                this.selAdvisoryFirm = <domains.IAdvisoryFirm>{ id: this.household.advisoryFirmId };
                //console.log("Loaded household: ", this.household, this.selAdvisoryFirm);
                this.selAccountGroupView = { value: this.household.accountGroupView };
                this.selDefaultAccountGroupView = { value: this.household.defaultAccountGroupView };

                this.bindHouseholdSelections();

                return this.household;
            }, err => this.generalService.showError(err));
        }

        accountGroupViewChanged() {
            this.filterDefaultAccountGroupViews();
        }

        filterDefaultAccountGroupViews() {

            if (!this.accountGroupViews) {
                return;
            }

            // console.log("FilterDefaultAccountGroupViews fired ");
            if (this.selAccountGroupView.value == domains.AccountGroupView.ALL) {
                this.defaultAccountGroupViews = this.accountGroupViews.filter(f => f.value != domains.AccountGroupView.ALL);
                // console.log("1# DefaulAccountGroupViews", this.defaultAccountGroupViews);
                if (!this.selDefaultAccountGroupView) {
                    this.selDefaultAccountGroupView = { value: domains.AccountGroupView.RTG };
                    // console.log("1# DefaulAccountGroupView defaulted to ", this.selDefaultAccountGroupView.value);
                }
            } else {
                this.defaultAccountGroupViews = this.accountGroupViews.filter(f => f.value == this.selAccountGroupView.value);
                // console.log("2# DefaulAccountGroupViews", this.defaultAccountGroupViews);
                this.selDefaultAccountGroupView = this.defaultAccountGroupViews[0];
                // console.log("2# DefaulAccountGroupView defaulted to ", this.selDefaultAccountGroupView.value);
            }
        }

        loadLovs() {
            this.generalService.getLOVs()
                .then(data => {

                    this.lovs = data;
                    this.accountGroupViews = this.lovs.filter(f => f.lovType == domains.LovType.ACCOUNT_GROUP_VIEW);
                    this.citizenships = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                    this.states = this.lovs.filter(v => v.lovType === domains.LovType.STATES);
                    if (!this.selAccountGroupView) {
                        this.selAccountGroupView = { value: domains.AccountGroupView.RTG };
                    }
                    this.filterDefaultAccountGroupViews();

                    if (this.household && this.household.id) {
                        this.bindHouseholdSelections();
                    }

                }, err => this.generalService.showError(err));
        }

        $onInit(): void {
            this.loadAdvisoryFirms();
            this.loadLovs();
        }

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }                        
            for (var key in evt) {
                if (key === "household") {
                    if (!this.household) {
                        this.household = { investors: [], advisoryFirmId: this.advisoryFirmId, accountGroupView: 1, defaultAccountGroupView: 1 };
                    }

                    this.selAdvisoryFirm = <domains.IAdvisoryFirm>{ id: this.household.advisoryFirmId | this.advisoryFirmId };
                    this.selAccountGroupView = { value: this.household.accountGroupView };
                    this.selDefaultAccountGroupView = { value: this.household.defaultAccountGroupView };
                    this.filterDefaultAccountGroupViews();
                    this.bindHouseholdSelections();
                    // console.log("Setting DefaultAccountGroupView to:", this.selDefaultAccountGroupView);

                    // 7 July 18, GL -  Commenting this out... looks like loadHousehold() already returns the RTGs via advisorService.getHousehold.
                    //                  Leaving this uncommented can cause a race condition where an empty RTG list gets loaded
                    //                  (in the case where this.household.id is undefined at the time this section is reached).
                    //                  This is also used by select-cu-household.html, but the list of existing RTGs does not
                    //                  currently need to be exposed inside that VM.
                    //load household rtgs
                    //if (!this.household.rtgs || this.household.rtgs.length <= 0) {
                    //    this.advisorService.getRTGByHousehold(this.household.id)
                    //        .then(response => this.household.rtgs = response.data, err => this.generalService.showError(err));
                    //}

                    //reload household if there is no investors
                    if (this.household.id > 0 && this.household.investors && this.household.investors.length <= 0) {
                        //console.log("There is no investors for HH. Reloading HH...");
                        this.loadHousehold(this.household.id);
                    }
                } else if (key === "advisoryFirmId" && this.advisoryFirmId > 0) {
                    this.selAdvisoryFirm = <domains.IAdvisoryFirm>{ id: this.household.advisoryFirmId };
                    //console.log("Setting advisory firm of HH to:", this.selAdvisoryFirm);
                }
            }
        }

        $routerOnActivate(next, previous) {
        }
    }

    class CuHousehold implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = CuHouseholdController;
            this.controllerAs = "vm";
            this.bindings = {
                household: "<",
                advisoryFirmId: "<",
                onHouseholdCu: "&",
                onRtgCu: "&"
            };
            this.templateUrl = "spa/shared/common/cu-household.html";
        }
    }
    angular.module(Constants.APP).component("cuHousehold", new CuHousehold());
}